<template>
  <header id="head is-uppercase">
    <b-navbar id="nav" fixed-top>
      <template slot="brand">
        <b-navbar-item tag="router-link" :to="{ name: 'home' }">
          <img src="@/assets/logo_sixthsense.png" alt="SixthSense" />
        </b-navbar-item>
      </template>
      <template slot="end">
        <div
          class="navbar-item has-menu is-hoverable"
          :class="{ 'is-active-menu': 'home' == $route.name }"
        >
          <router-link class="navbar-link is-arrowless" :to="{ name: 'home' }">
            ¿Quiénes somos?
          </router-link>
          <div class="navbar-dropdown">
            <b-navbar-item
              tag="router-link"
              :to="{ name: 'home', hash: '#equipo' }"
            >
              Equipo
            </b-navbar-item>
            <b-navbar-item
              tag="router-link"
              :to="{ name: 'home', hash: '#metodologia' }"
            >
              Metodología
            </b-navbar-item>
          </div>
        </div>
        <div
          class="navbar-item has-menu is-hoverable"
          :class="{ 'is-active-menu': 'strength' == $route.name }"
        >
          <router-link
            class="navbar-link is-arrowless"
            :to="{ name: 'strength' }"
          >
            Nuestras fortalezas
          </router-link>
          <div class="navbar-dropdown">
            <b-navbar-item
              tag="router-link"
              :to="{ name: 'strength', hash: '#trabajo' }"
            >
              Nuestro trabajo
            </b-navbar-item>
          </div>
        </div>
        <b-navbar-item tag="router-link" :to="{ name: 'customers' }">
          Clientes
        </b-navbar-item>
        <b-navbar-item tag="router-link" :to="{ name: 'contact' }">
          Contacto
        </b-navbar-item>
      </template>
    </b-navbar>
  </header>
</template>

<script>
export default {
  name: "MainMenu"
};
</script>

<style lang="scss">
#nav {
  min-height: 96px;
  background-color: transparent;
  color: #000;
  background-color: #f6f6f6;
}

@media screen and (min-width: 1024px) {
  .navbar-end {
    > .navbar-item {
      align-items: flex-start;
      padding-top: 0.3em;
      padding-left: 0;

      &:hover,
      &.is-active-menu,
      &.router-link-exact-active {
        font-weight: bold;
      }

      &:hover::after {
        font-weight: normal;
      }

      &::after {
        content: "/";
        margin-left: 1em;
      }

      &:last-child:after {
        content: "";
      }
    }

    .navbar-item,
    .navbar-link {
      color: #000;
      font-size: 1rem;
    }

    .navbar-dropdown {
      .navbar-item,
      .router-link-exact-active,
      .router-link-active {
        font-weight: normal;
        padding-left: 0;

        &:hover {
          font-weight: normal;
        }
      }
    }

    .has-menu {
      > .navbar-link {
        padding-top: 0;
        padding-left: 0;
        padding-right: 0;
      }

      /*&.is-active-menu {
        .navbar-dropdown {
          display: block;
        }
      }*/
    }
  }
}
</style>
